import React from "react";
import { Link } from "react-router-dom";
import { SideBar } from "../sidebar";
import {
  getAllAuctionsByGroup,
  getAllAuctionsByOrg,
  getFinalReport,
  sendFinalReport,
} from "../../../models/auctions";
import { getAllOrganization } from "../../../models/organization";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import i18n from "../../../i18n";
import { Spinner } from "react-bootstrap";
import { apiUrl } from "../../../constants/global";
import { getLoggedUser } from "../../../state/user";
import { getGroupsList, updateProjectCode } from "../../../models/groups";
import { HomeBanner } from "../../home/homeBanner";
import { EditableCell } from "../../common/editable_cell";
import { updateUserDetails } from "../../../models/users";
import Select from "react-select";
let lang = localStorage.getItem('I18N_LANGUAGE');

const user = getLoggedUser();

export class FinalReport extends React.Component {
  constructor() {
    super();
    this.state = {
      input: {
        downloadDoc: "pdf",
        auction: [],   // 👈 must be array for multi select
        group: "" ,
        project_code: ""  
      },
      groups: [],
      organizations: {},
      titles: [],
      bidders: [],
      phone_loader: false,
      open_popup: false,
      bidder_loading: false,
      customStyles: {
        headCells: {
          style: {
            fontWeight: "bold",
            backgroundColor: "#dadada",
            color: "#000000",
          },
        },
      },
      //actionsMemo : React.useMemo(() => <Export onExport={() => downloadCSV(data)} />, []),
      columns: [
        {
          name: i18n.t("bidder_id"),
          selector: "id",
          sortable: true,
          wrap: true,
        },
        {
          name: "Auction ID",
          selector: "auction_id",
          sortable: true,
          wrap: true,
        },
        {
          name: "Auction",
          selector: "group_id",
          sortable: true,
          wrap: true,
          cell: (row) => (row && row.auction ? row.auction.title : ""),
        },
        {
          name: "Name",
          selector: "name",
          cell: (row) => <span>{row.user.name}</span>,
        },
        {
          name: "Actual Name",
          selector: "actual_name",
          cell: (row) => (
            <EditableCell
              value={row.user?.actual_name}
              userId={row.user?.id}
              onSave={this.handleActualNameSave}
            />
          ),
        },
        {
          name: i18n.t("username"),
          selector: "username",
          cell: (row) => <span>{row.user.username}</span>,
        },
        {
          name: "CR Number",
          selector: "cr_number",
          cell: (row) => <span>{row.user.cr_number}</span>,
        },
        {
          name: i18n.t("latest_bid_amount"),
          selector: "bid_amount",
          sortable: true,
        },
        {
          name: i18n.t("winner"),
          selector: "winner",
          sortable: true,
          cell: (row) => <span>{row.winner ? "Winner" : ""}</span>,
        },
        {
          name: "Bid Date",
          selector: "created_at",
          sortable: true,
        },
        // {
        //   name: i18n.t("title"),
        //   wrap: true,
        //   selector: "title",
        //   cell: (row) => (
        //     <span>
        //       {row.auction.title}
        //       <br />
        //       {row.auction.title_ar}
        //     </span>
        //   ),
        // },
        {
          name: i18n.t("end_date"),
          selector: "end_date",
          wrap: true,
          cell: (row) => <span>{row.auction.end_date}</span>,
        },
      ],
    };

    this.handleChange = this.handleChange.bind(this);
    this.loadAuctionsByGrp = this.loadAuctionsByGrp.bind(this);
    this.loadData = this.loadData.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.handleActualNameSave = this.handleActualNameSave.bind(this);

  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.loadAllOrganization();
    this.loadAllGroups();
    //this.loadData();
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
    if (event.target.name === "group") {
      this.loadAuctionsByGrp(event.target.value);
    }
  }

  async updateProjectCode() {
  try {
    const { group, project_code } = this.state.input;
    if (!group || !project_code) {
      swal("Error", "Please select group and enter project code", "error");
      return;
    }

    const response = await updateProjectCode(group, { project_code });
    if (response && response.success) {
      swal("Success", "Project code updated successfully", "success");
    }
  } catch (err) {
    console.error("Error updating project code:", err);
    swal("Error", "Failed to update project code", "error");
  }
}


  async handleActualNameSave(userId, newName) {
    try {
      const payload = { actual_name: newName }; // 👈 wrap inside an object

      const response = await updateUserDetails(payload, userId);

      // Refresh bidder data after update
      this.loadData();
    } catch (err) {
      console.error("Error saving actual_name:", err);
    }
  }



  async loadAllOrganization() {
    const response = await getAllOrganization();
    let organizations = response.data;
    this.setState({ organizations });
  }

  async loadAllGroups() {
    const response = await getGroupsList();
    let groups = response.data;
    this.setState({ groups });
  }

  async loadAuctionsByGrp(org) {
    if (org) {
      this.setState({ phone_loader: true });
      const response = await getAllAuctionsByGroup(org);
      if (response.data) {
        this.setState({ phone_loader: false });
        this.setState({ titles: response.data });
        let _data = response.data;
        if (_data && _data.length) {
          let organization = _data[0].organization;
          let { input } = this.state;
          input.organization = organization;
          this.setState({ input });
        }
      }
    }
  }

  async loadData() {
    this.setState({ bidder_loading: true });
    const response = await getFinalReport(this.state.input);
    if (response.data) {
      this.setState({ bidder_loading: false });
      this.setState({ bidders: response.data });
    }
  }

  async sendMail() {
    let input = this.state.input;
    const response = await sendFinalReport(input);
    if (response && response.success) {
      swal(i18n.t("success"), i18n.t("email_sent_notification"), "success");
    }
  }

  render() {
    let organizations = this.state.organizations;
    let groups = this.state.groups;
    let titles = this.state.titles;
    let bidders = this.state.bidders;
    return (
      <React.Fragment>
        <HomeBanner />

        <section className="sptb mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? "col-xl-12 col-lg-12 col-md-12"
                    : "col-xl-9 col-lg-12 col-md-12"
                }
              >
                <form
                  id="UpdateProfile"
                  className="card mb-0"
                  autoComplete="off"
                >
                  <div className="card-header">
                    <h3 className="card-title">
                      <span
                        style={{ fontSize: "1rem", marginRight: "0.5rem" }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && (
                          <i className="icon-size-actual"></i>
                        )}
                        {!this.state.hideSidebar && (
                          <i className="icon-size-fullscreen"></i>
                        )}
                      </span>
                      {i18n.t("search")}
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="row d-flex align-items-center">
                      {/* <div className="col-sm-12 col-md-3">
                        <div className="form-group">
                          <label className="form-label">
                            {i18n.t("organization")}
                          </label>
                          <select
                            className="form-control"
                            data-placeholder="Select Class"
                            name="organization"
                            value={this.state.input.organization}
                            onChange={this.handleChange}
                          >
                            <option value="">
                              --{i18n.t("organization")}--
                            </option>
                            {organizations.length > 0 &&
                              organizations.map((item) => {
                                return (
                                  <option value={item.id} key={item.id}>
                                    {item.organization_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div> */}
                      <div className="col-sm-12 col-md-4">
                        <div className="form-group">
                          <label className="form-label">
                            {i18n.t("auction_group")}
                          </label>
                          <select
                            className="form-control"
                            data-placeholder="Select Class"
                            name="group"
                            value={this.state.input.group}
                            onChange={this.handleChange}
                          >
                            <option value="">--{i18n.t("group")}--</option>
                            {groups.length > 0 &&
                              groups.map((item) => {
                                return (
                                  <option value={item.id} key={item.id}>
                                    {item.group_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>





                      <div className="col-sm-12 col-md-2">
                        <div className="form-group">
                          <label className="form-label">&nbsp;</label>
                          <button
                            type="button"
                            className="btn btn-primary btn-block"
                            onClick={this.loadData}
                            disabled={!this.state.input.group}
                          >
                            {i18n.t("search")}
                          </button>
                        </div>
                      </div>

                      <div className="col-sm-12 col-md-4">
                        <div className="form-group">
                          <label className="form-label">Project Code</label>
                          <input
                            type="text"
                            className="form-control"
                            name="project_code"
                            value={this.state.input.project_code}
                            onChange={this.handleChange}
                            placeholder="Enter project code"
                          />
                        </div>
                      </div>

                      <div className="col-sm-12 col-md-2">
                        <div className="form-group">
                          <label className="form-label">&nbsp;</label>
                          <button
                            type="button"
                            className="btn btn-secondary btn-block"
                            onClick={() => this.updateProjectCode()}
                            disabled={!this.state.input.group || !this.state.input.project_code}
                          >
                            Save Project Code
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <hr />

                <div className="card mb-0">
                  <div className="card-header pb-0">
                    <h3 className="card-title" style={{ width: "65%" }}>
                      {i18n.t("result")}
                    </h3>
                    {bidders.length > 0 && (
                      <form
                        className="form-inline d-flex"
                        action=""
                        method="post"
                        target="_new"
                        style={{ width: "35%" }}
                        onSubmit={this.downloadDoc}
                      >
                        <div className="form-group mx-sm-3">
                          <select
                            className="form-control"
                            name="downloadType"
                            value={this.state.input.downloadType}
                            onChange={this.handleChange}
                          >
                            <option value={""}>Download As</option>
                            <option value={"pdf-ar"}>PDF (AR)</option>
                            <option value={"pdf-en"}>PDF (EN)</option>
                            <option value={"excel"}>Excel</option>
                          </select>
                        </div>
                        {this.state.input.downloadType !== "" && (
                          <a
                            type="submit"
                            target="_new"
                            href={
                              apiUrl +
                              "final_report/export?q=" +
                              this.state.input.downloadType +
                              "&org=" +
                              this.state.input.organization +
                              "&group=" +
                              this.state.input.group +
                              "&auction=" +
                              this.state.input.auction +
                              "&u=" +
                              user.role
                            }
                            className="btn btn-outline-danger btn-sm "
                          >
                            {i18n.t("download")}
                          </a>


                        )}
                      </form>
                    )}
                  </div>
                  <div className="card-body pt-0">
                    <div className="table-responsive ">
                      {this.state.bidder_loading && (
                        <div className="text-center">
                          <Spinner animation="border" />
                        </div>
                      )}
                      {!this.state.bidder_loading && !bidders.length && (
                        <div className="alert alert-danger">
                          {i18n.t("no_result")}
                        </div>
                      )}
                      {bidders.length > 0 && (
                        <div className="table-wrapper">
                          <DataTable
                            title=""
                            columns={this.state.columns}
                            data={bidders}
                            customStyles={this.state.customStyles}
                            highlightOnHover
                            pagination
                            paginationPerPage={15}
                            paginationRowsPerPageOptions={[15, 25, 50, 100]}
                            paginationComponentOptions={{
                              rowsPerPageText: "Bidders per page:",
                              rangeSeparatorText: i18n.t("out"),
                            }}
                          //actions={this.state.actionsMemo}
                          />
                        </div>
                      )}
                    </div>

                    {(user.role === "A" || user.role === "M") &&
                      bidders.length > 0 && (
                        <button
                          type="button"
                          className="btn btn-info"
                          onClick={this.sendMail}
                        >
                          Send report to the client
                        </button>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
